import { useState } from "react";
import { Link, useNavigate, useOutletContext } from "react-router-dom";
import "./GuitarTabs.css";
import { apiFetch } from "../Utility/api";

const defaultFormState = {
  songName: "",
  artist: "",
  tuning: "Standard",
  difficulty: "Intermediate",
  capo: "",
  tabContent: "",
  notes: "",
};

const GuitarTabsAdd = () => {
  const navigate = useNavigate();
  const { setData } = useOutletContext();
  const [formValues, setFormValues] = useState(defaultFormState);
  const [saveMessage, setSaveMessage] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues((currentValues) => ({
      ...currentValues,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSaving(true);
    setSaveMessage("");

    try {
      const response = await apiFetch("/tabs/server/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formValues),
      });

      const result = await response.json();
      const createdTab = result.tab;

      if (setData) {
        setData((currentData) => (currentData ? [createdTab, ...currentData] : [createdTab]));
      }

      navigate(`/guitar-tabs/view?tab=${createdTab.id}`, {
        state: { message: "Tab saved successfully." },
      });
    } catch (submitError) {
      setSaveMessage("There was a problem saving your tab.");
      setIsSaving(false);
    }
  };

  return (
    <div className="GuitarTabsPage">
      <section className="GuitarTabsPanel GuitarTabsFormShell">
        <div className="GuitarTabsSectionHeader">
          <h2>Add a tab</h2>
          <p>Save the song details and keep the tab formatting exactly the way you use it.</p>
        </div>

        <form className="GuitarTabsForm" onSubmit={handleSubmit}>
          <label>
            Song name
            <input
              name="songName"
              value={formValues.songName}
              onChange={handleInputChange}
              required
            />
          </label>

          <label>
            Artist
            <input
              name="artist"
              value={formValues.artist}
              onChange={handleInputChange}
              required
            />
          </label>

          <div className="GuitarTabsFormRow">
            <label>
              Tuning
              <input name="tuning" value={formValues.tuning} onChange={handleInputChange} />
            </label>

            <label>
              Difficulty
              <select
                name="difficulty"
                value={formValues.difficulty}
                onChange={handleInputChange}
              >
                <option value="Beginner">Beginner</option>
                <option value="Intermediate">Intermediate</option>
                <option value="Advanced">Advanced</option>
              </select>
            </label>
          </div>

          <label>
            Capo
            <input
              name="capo"
              value={formValues.capo}
              onChange={handleInputChange}
              placeholder="e.g. 2"
            />
          </label>

          <label>
            Tab content
            <textarea
              name="tabContent"
              value={formValues.tabContent}
              onChange={handleInputChange}
              rows="16"
              required
            />
          </label>

          <label>
            Notes
            <textarea
              name="notes"
              value={formValues.notes}
              onChange={handleInputChange}
              rows="4"
            />
          </label>

          <div className="GuitarTabsButtonRow">
            <button className="GuitarTabsButton" type="submit" disabled={isSaving}>
              {isSaving ? "Saving..." : "Save Tab"}
            </button>
            <Link className="GuitarTabsSecondaryLink" to="/guitar-tabs">
              Back to Library
            </Link>
          </div>

          {saveMessage ? <p className="GuitarTabsMessage">{saveMessage}</p> : null}
        </form>
      </section>
    </div>
  );
};

export default GuitarTabsAdd;
